import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classnames from 'classnames';
import React from 'react';
import alertUserOfDeprecatedProps from '../utils/deprecation.js';

var _excluded = ["as", "className", "src", "alt", "position", "height", "width", "type"];
var Image = function Image(props) {
  var _classnames;
  var _props$as = props.as,
    As = _props$as === void 0 ? 'div' : _props$as,
    className = props.className,
    src = props.src,
    alt = props.alt,
    _props$position = props.position,
    position = _props$position === void 0 ? 'center-center' : _props$position,
    _props$height = props.height,
    height = _props$height === void 0 ? '100px' : _props$height,
    _props$width = props.width,
    width = _props$width === void 0 ? '100px' : _props$width,
    _props$type = props.type,
    type = _props$type === void 0 ? 'cover' : _props$type,
    otherProps = _objectWithoutProperties(props, _excluded);
  alertUserOfDeprecatedProps('Image', otherProps);
  if (!alt) {
    console.error('Hey Canvas User! The Image component requires alt text so that screenreaders can tell users what the image is.');
  }
  var finalClasses = classnames('C-Image', (_classnames = {}, _defineProperty(_classnames, "--position-".concat(position), position), _defineProperty(_classnames, "--type-".concat(type), type), _classnames), className);
  var backgroundImageStyle = {
    backgroundImage: 'url(' + src + ')',
    paddingBottom: height,
    paddingRight: width,
    width: width
  };
  return /*#__PURE__*/React.createElement(As, _extends({
    className: finalClasses
  }, otherProps, {
    role: "img",
    style: backgroundImageStyle,
    alt: alt
  }));
};
Image.displayName = 'Image';

export { Image as default };
